import React from 'react';
import {BOOKING_STATUSES_UI} from "../constant";
import {Box, Typography} from "@mui/material";

const StatusTag = ({status, isDarkMode}) => {
    const {content_color, background_color, text, icon: Icon} = BOOKING_STATUSES_UI(isDarkMode)[status] || {};

    return (
        <Box
            display="flex"
            alignItems="center"
            gap="8px"
            padding="8px 12px"
            sx={{
                color: content_color,
                background: background_color,
                borderColor: content_color,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '4px',
            }}
        >
            {Icon && <Icon color={content_color}/>}
            <Typography
                color={content_color}
                fontWeight={400}
                fontSize={16}
                lineHeight={1}
                fontFamily="'Outfit', sans-serif"
            >{text}
            </Typography>
        </Box>
    );
}

export default StatusTag;